module.exports = "<ui-view class=\"ui-redesign\"></ui-view>\n";